/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Types_Feature_RequestInputs */

const es_feedback_types_feature_request = /** @type {(inputs: Feedback_Types_Feature_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitud de Feature`)
};

const en_feedback_types_feature_request = /** @type {(inputs: Feedback_Types_Feature_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature Request`)
};

/**
* | output |
* | --- |
* | "Feature Request" |
*
* @param {Feedback_Types_Feature_RequestInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_types_feature_request = /** @type {((inputs?: Feedback_Types_Feature_RequestInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Types_Feature_RequestInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_types_feature_request(inputs)
	return en_feedback_types_feature_request(inputs)
});
export { feedback_types_feature_request as "feedback.types.feature_request" }